<script lang="ts">
    import {navigating} from '$app/stores';
    import {derived} from 'svelte/store';

    export let delay = 200;

    let timer: any;
    const navigationIsDelayed = derived(navigating, (newValue, set) => {
        if (timer) {
            clearTimeout(timer);
        }
        if (newValue) {
            timer = setTimeout(() => set(true), delay);
        }
        set(false);
    });
</script>

{#if $navigationIsDelayed}
    <div class="pending fixed z-[10000] top-0 right-0 pointer-events-none bg-green"></div>
{/if}

<style lang="postcss">
    .pending {
        height: 3px;
        animation: pending 1.8s linear infinite;
    }

    @keyframes pending {
        from {
            left: -30%;
            width: 15%;
        }
        50% {
            width: 30%;
        }
        70% {
            width: 60%;
        }
        80% {
            left: 50%;
        }
        95% {
            left: 80%;
            width: 40%;
        }
        to {
            left: 100%;
        }
    }
</style>
